import { Navigate, useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "./AuthContext";

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { t } = useTranslation();
  const { user, status } = useAuth();
  const { locale } = useParams();
  const location = useLocation();

  if (status === "loading") return <p>{t("common.loading")}</p>;
  if (!user) return <Navigate to={`/${locale || "en"}/login`} state={{ from: location.pathname }} replace />;

  return <>{children}</>;
}
